var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "totals-box mb-2",
      class: _vm.total.price_changed ? "outline-red" : "",
      on: {
        click: function($event) {
          $event.stopPropagation()
          $event.preventDefault()
          _vm.$emit("openSidebar")
        }
      }
    },
    [
      _c("div", { staticClass: "d-flex p-0 col-2 justify-content-between" }, [
        _c("div", { staticClass: "totals-info-wrapper col-4 p-0" }, [
          _c("a", { attrs: { href: "#" } }, [
            _c(
              "div",
              {
                staticClass: "total-ref-id pointer",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.goToJob($event)
                  }
                }
              },
              [_vm._v(_vm._s(_vm.total.ref_id))]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "total-info" }, [
            _vm._v("\n        " + _vm._s(_vm.total.sales) + "\n      ")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "totals-info-wrapper col-4 p-0" }, [
          _c("div", { staticClass: "total-info" }, [
            _vm._v("\n        " + _vm._s(_vm.total.company_name) + "\n      ")
          ]),
          _vm._v(" "),
          _vm.total.carrier
            ? _c("div", { staticClass: "total-info" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.total.carrier.name) + "\n      "
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "totals-info-wrapper col-4 p-0" }, [
          _c("div", { staticClass: "total-info" }, [
            _vm._v("\n        " + _vm._s(_vm.total.date) + "\n      ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "total-info" }, [
            _c("i", { staticClass: "fa fa-user totals-icon" }),
            _vm._v("\n        " + _vm._s(_vm.total.movers) + "\n      ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "total-info" }, [
            _vm._v("\n        $" + _vm._s(_vm.total.rate) + "\n      ")
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "totals-info-wrapper col-1 p-0" }, [
        _c("div", { staticClass: "total-info-numbers" }, [
          _vm._v("\n      " + _vm._s(_vm.total.time) + "\n    ")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "totals-info-wrapper col-1 p-0" }, [
        _c("div", { staticClass: "total-info-numbers" }, [
          _vm._v("\n      " + _vm._s(_vm.total.cash_payment) + "\n    ")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "totals-info-wrapper col-1 p-0" }, [
        _c("div", { staticClass: "total-info-numbers" }, [
          _vm._v("\n      " + _vm._s(_vm.total.total_credit) + "\n    ")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "totals-info-wrapper col-1 p-0" }, [
        _c("div", { staticClass: "total-info-numbers" }, [
          _vm._v("\n      " + _vm._s(_vm.total.total_price) + "\n      "),
          _vm.total.price_changed
            ? _c("span", { staticClass: "red-text" }, [
                _vm._v(
                  "\n         (" +
                    _vm._s(_vm.total.price_difference) +
                    ")\n      "
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "totals-info-wrapper col-1 p-0" }, [
        _c("div", { staticClass: "total-info-numbers" }, [
          _vm._v("\n      " + _vm._s(_vm.total.deposit) + "\n    ")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "totals-info-wrapper col-1 p-0" }, [
        _c("div", { staticClass: "total-info-numbers" }, [
          _vm._v("\n      " + _vm._s(_vm.total.carrier_total) + "\n    ")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "totals-info-wrapper col-1 p-0" }, [
        _c("div", { staticClass: "total-info-numbers" }, [
          _vm._v("\n      " + _vm._s(_vm.total.cluster_total) + "\n    ")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "totals-info-wrapper col-1 p-0" }, [
        _c("div", { staticClass: "total-info-numbers" }, [
          _vm._v("\n      " + _vm._s(_vm.total.balance) + "\n    ")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "totals-info-wrapper col-1 p-0" }, [
        _c("div", { staticClass: "total-info-numbers" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.total.mod_tier_id
                  ? _vm.total.mod_tier_percentage + "%"
                  : _vm.total.percent + "% (" + _vm.total.fee + ")"
              ) +
              "\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "totals-info-wrapper col-1 p-0" }, [
        _c(
          "div",
          { staticClass: "d-flex align-items-center justify-content-between" },
          [
            _c("div", { staticClass: "total-info-numbers" }, [
              _vm._v("\n        " + _vm._s(_vm.total.card_tips) + "\n      ")
            ]),
            _vm._v(" "),
            _vm.total.payment_status_id === 3
              ? _c("span", { staticClass: "mr-2 total-status-paid" }, [
                  _vm._v("\n        paid\n      ")
                ])
              : _vm._e()
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b4922ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b4922ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/TotalsBlock.vue
// module id = null
// module chunks = 